module.exports = "## 一个依赖一个收集器\n```\nconst state = {\n  param: 'some string...',\n  watch: {\n    param: [],\n  }\n}\n```\n## 渲染一个模板往收集器丢一个依赖\n```\nconst watcher = function () {\n  // render template a\n}\nwatcher();\nstate.watch.param.push(watcher);\n```\n## 变量改动时，去遍历所有的依赖\n```\nfor (let i = 0; i < state.watch.param.length; i++) {\n  state.watch.param[i]();\n}\n```"


//////////////////
// WEBPACK FOOTER
// ./src/store/dependencesum.md
// module id = 150
// module chunks = 2